// Project types grouped in the families of the Project management page (US 9396)
export const FAMILIES = [
  {key: 'assessments', types: ['control_assessment', 'risk_assessment', 'bia_assessment']},
  {key: 'records', types: ['update', 'validation']},
  {key: 'controls', types: ['control', 'security_measure']}
];

const TYPES = {
  control_assessment: {family: 'assessments', icon: 'clipboard-list', color: 'teal'},
  risk_assessment: {family: 'assessments', icon: 'exclamation-triangle', color: 'rose'},
  bia_assessment: {family: 'assessments', icon: 'wave-square', color: 'violet'},
  update: {family: 'records', icon: 'sync-alt', color: 'blue'},
  validation: {family: 'records', icon: 'check-double', color: 'blue'},
  control: {family: 'controls', icon: 'shield-alt', color: 'amber'},
  security_measure: {family: 'controls', icon: 'lock', color: 'amber'}
};

export function typeMeta(type) {
  return TYPES[type] || {family: '', icon: 'folder-open', color: 'grey'};
}

// Families the client's modules allow, with the same rules as the old project menu
export function allowedFamilies(client) {
  client = client || {};
  return FAMILIES.filter(function(family) {
    if (family.key === 'assessments') {
      return !!client.assessmentModule;
    }
    if (family.key === 'records') {
      return !!(client.processingActivitiesModule || client.systemModule || client.contractBasicModule);
    }
    return !!client.riskModule;
  });
}

export function familyTypes(key) {
  let family = FAMILIES.find(function(item) {
    return item.key === key;
  });
  return family ? family.types : [];
}

const UNITS = {Days: 'days', Months: 'months', Years: 'years'};

// Run dates of a scheduled recurring project from a date on, worked out like nextRun on the server
export function runDates(project, from, count) {
  var moment = require('moment');
  let every = parseInt(project.repeat_after, 10);
  if (!project.scheduled || !project.start_date || !(every > 0) || !UNITS[project.repeat_after_interval]) {
    return [];
  }
  let start = moment(project.start_date.substring(0, 10));
  let limit = moment(from).startOf('day');
  let dates = [];
  for (let i = 0; dates.length < count && i < 10000; i++) {
    let date = start.clone().add(every * i, UNITS[project.repeat_after_interval]);
    if (!date.isBefore(limit)) {
      dates.push(date);
    }
  }
  return dates;
}

export function nextRunDate(project) {
  var moment = require('moment');
  let dates = runDates(project, moment(), 1);
  return dates.length ? dates[0] : null;
}
